import { oauthEnvironmentMessageKey } from "../platforms/oauth-popup-errors.js";

/**
 * Maps stable backend Instagram OAuth popup error codes to i18n keys.
 * Never surface raw Meta error_description.
 */

export function instagramOauthErrorMessageKey(code: string): string {
  const environmentKey = oauthEnvironmentMessageKey("instagram", code);
  if (environmentKey) return environmentKey;
  switch (code) {
    case "OAUTH_ACCESS_DENIED":
      return "instagram.popupError.accessDenied";
    case "OAUTH_STATE_INVALID":
      return "instagram.popupError.stateInvalid";
    case "INSTAGRAM_PROVIDER_ERROR":
      return "instagram.popupError.provider";
    default:
      return "instagram.popupError.generic";
  }
}
